import React from 'react';
import styles from './Menu.module.css';
import { CloseSvg } from '../../SVGComponents/SVGComponents';
export default function Menu({ menuOpen, toggleMenu }) {
  return (
    <div className={menuOpen ? styles.container + ' ' + styles.menuOpen : styles.container}>
      <div className={styles.content_wrapper}>
        <button className={styles.close_btn} onClick={() => toggleMenu(false)}>
          <CloseSvg width={40} height={40} />
        </button>
        <ul className={styles.list_wrapper}>
          <li>
            <a href="#1" className="anchor-link" onClick={() => toggleMenu(false)}>
              Що ти отримаєш?
            </a>
          </li>
          <li>
            <a href="#3" className="anchor-link" onClick={() => toggleMenu(false)}>
              Як це працює?
            </a>
          </li>
          <li>
            <a href="#2" className="anchor-link" onClick={() => toggleMenu(false)}>
              Автор та куратор програми
            </a>
          </li>
          <li>
            <a href="#5" className="anchor-link" onClick={() => toggleMenu(false)}>
              Вартість участі
            </a>
          </li>
          <li>
            <a href="#4" className="anchor-link" onClick={() => toggleMenu(false)}>
              Результати
            </a>
          </li>
          <li>
            <a href="#6" className="anchor-link" onClick={() => toggleMenu(false)}>
              Відповіді на питання?
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
